import styled from "styled-components"
import styleWithOrgDesign from "QuorumGrassroots/styled-components/connect"
import { Container as GotvV2Container } from "QuorumGrassroots/campaign-forms/components/GotvV2Form/GotvV2Form.styles"

export const Wrapper = styleWithOrgDesign(styled.div`
    padding: 2rem;
    @media (max-width: 768px) {
        padding: 1.5rem;
    }
`)

export const Container = styled(GotvV2Container)`
    max-width: 720px;
    min-height: 80vh;
    font-size: 16px;
    justify-content: flex-start;
`
